export default "__VITE_ASSET__CjdX9gd___"